import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CompanyVerificationEffects } from './store/company-verification.effects';
import {
  CompanyVerificationNamespace,
  CompanyVerificationReducer,
} from './store/company-verification.store';

@NgModule({
  imports: [
    StoreModule.forFeature(CompanyVerificationNamespace, CompanyVerificationReducer),
    EffectsModule.forFeature([CompanyVerificationEffects]),
  ],
})
export class TellentCompanyVerificationDataModule {}
